/* va-sizecheck.js - "you typed 10 mL but picked the 3 mL label" guard.
 *
 * Owner 2026-09-22 (order #1794, Ivan: "my acidic water labels are correct but
 * not the right size, they were supposed to be 10ml"): he typed "10 mL" into the
 * strength field of a line he had added on the 3 mL label size, so it printed
 * exactly as ordered - at 3 mL. Owner: "if they put 10ml ... make a popup saying
 * you selected 3ml and you typed 10ml, to switch - prevent future issues".
 *
 * What this does, on every builder that sells labels:
 *   - classic builder + mobile wizard (sections/vialart.liquid, va-builder2.js):
 *       popup offers "Switch to 10 mL labels" (window.vaSetDie('10ml')).
 *   - builder v3: calls window.vaSizeCheck.prompt() from inside its own IIFE
 *       (it owns state.size / switchSize), see sections/va-builder-v3.liquid.
 *   - beta builder (/pages/build-beta) and Bulk Mix: 3 mL only, so the popup
 *       offers to open the classic builder on 10 mL with the text carried over.
 * It fires (a) once when a field is committed with "10 mL" on a 3 mL label and
 * (b) at Add to Cart / Review if it is still mismatched. "Keep 3 mL labels" is
 * remembered for that exact text for the session, so it never nags twice.
 * Never blocks a sale: Keep always continues exactly where the customer was.
 */
(function () {
  if (window.vaSizeCheck) return;

  /* "10 mL", "10mL", "10 mls", "10.0 mL", "10-mL", "10cc", "10 CCs", "10 milliliters".
     Not "1.0 mL", "0.10 mL", "110 mL", "100mL", "10 mg/mL". */
  var RX = /(^|[^0-9.,])10(?:\.0+)?\s*-?\s*(?:m\s*l|cc|millilit(?:er|re))s?\b/i;
  var TEN_URL = '/pages/classic-builder?size=10ml';

  function detect(texts) {
    for (var i = 0; i < texts.length; i++) {
      var t = String(texts[i] == null ? '' : texts[i]);
      if (t && RX.test(t)) return '10 mL';
    }
    return null;
  }

  /* What a "Keep 3 mL" answer is remembered against: ONLY the texts that carry
     the 10 mL, normalised and de-duplicated. Editing the lot, the date or any
     other line keeps the answer; changing or adding a 10 mL text asks again. */
  function sigOf(texts) {
    var out = [];
    for (var i = 0; i < texts.length; i++) {
      var t = String(texts[i] == null ? '' : texts[i]).toLowerCase().replace(/\s+/g, ' ').trim();
      if (t && RX.test(t) && out.indexOf(t) < 0) out.push(t);
    }
    out.sort();
    return out.join('|');
  }

  /* per-session memory of "Keep 3 mL" answers, keyed by the 10 mL text, and
     of what has already been nudged at typing time */
  var mem = {};
  function key(sig) { return 'va_szk:' + String(sig || '').toLowerCase().replace(/\s+/g, ' ').slice(0, 160); }
  function acked(sig) {
    if (mem[key(sig)] === 'keep') return true;
    try { return sessionStorage.getItem(key(sig)) === 'keep'; } catch (e) { return false; }
  }
  function ack(sig) {
    mem[key(sig)] = 'keep';
    try { sessionStorage.setItem(key(sig), 'keep'); } catch (e) {}
  }
  var nudged = {};

  /* ---------------------------------------------------------------- modal */
  var open = false, lastFocus = null;
  function css() {
    if (document.getElementById('va-szk-css')) return;
    var st = document.createElement('style');
    st.id = 'va-szk-css';
    st.textContent =
      /* flex-start + auto margins = centred when it fits, top-aligned and scrollable when it
         doesn't (landscape phone, large system text) - Keep must always be reachable */
      '#va-szk{position:fixed;inset:0;z-index:2147483600;display:flex;align-items:flex-start;justify-content:center;'
      + 'background:rgba(8,6,20,.72);padding:16px;overflow-y:auto;overscroll-behavior:contain;box-sizing:border-box;}'
      + '#va-szk .szk-card{margin:auto 0;box-sizing:border-box;}'
      + '#va-szk .szk-card:focus{outline:none;}'
      + '#va-szk .szk-card{max-width:440px;width:100%;background:#17132e;color:#efeaff;border:1px solid rgba(124,77,255,.55);'
      + 'border-radius:16px;padding:22px 20px 18px;box-shadow:0 20px 60px rgba(0,0,0,.6);'
      + 'font:500 14.5px/1.5 system-ui,-apple-system,"Segoe UI",sans-serif;}'
      + '#va-szk h3{margin:0 0 10px;font-size:18px;font-weight:800;color:#fff;}'
      + '#va-szk p{margin:0 0 10px;color:#d6d0f2;}'
      + '#va-szk .szk-sz{display:flex;gap:10px;margin:12px 0 16px;}'
      + '#va-szk .szk-sz div{flex:1;border:1px solid rgba(255,255,255,.14);border-radius:10px;padding:8px 10px;font-size:12.5px;color:#bdb5e0;}'
      + '#va-szk .szk-sz b{display:block;color:#fff;font-size:14px;}'
      + '#va-szk .szk-sz .on{border-color:#ffb74d;}'
      + '#va-szk .szk-stage{height:44px;display:flex;align-items:flex-end;margin:2px 0 8px;}'
      /* same sticker finish as the size picker (va-builder2.js vaSizeRow, 2026-09-22) */
      + '#va-szk .szk-lab{display:flex;align-items:center;justify-content:center;border-radius:4px;color:#35323f;'
      + 'font-size:10px;font-weight:700;letter-spacing:-.01em;background:linear-gradient(180deg,#fdfdff 0%,#e8e6f0 100%);'
      + 'box-shadow:0 1px 1.5px rgba(0,0,0,.45),0 8px 16px -10px rgba(0,0,0,.9);}'
      + '#va-szk .szk-acts{display:flex;flex-direction:column;gap:8px;}'
      + '#va-szk button,#va-szk a.szk-btn{display:block;width:100%;box-sizing:border-box;text-align:center;border-radius:10px;'
      + 'padding:12px 14px;font:800 14.5px/1.2 system-ui,-apple-system,"Segoe UI",sans-serif;cursor:pointer;text-decoration:none;}'
      + '#va-szk .szk-go{background:#7c4dff;color:#fff;border:0;}'
      + '#va-szk .szk-keep{background:transparent;color:#d6d0f2;border:1px solid rgba(255,255,255,.22);}'
      + '#va-szk button:focus-visible,#va-szk a.szk-btn:focus-visible{outline:3px solid #ffb74d;outline-offset:2px;}'
      + '#va-szk-toast{position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:2147483601;background:#1f7a46;'
      + 'color:#fff;padding:11px 16px;border-radius:10px;font:700 14px/1.4 system-ui,-apple-system,sans-serif;'
      + 'box-shadow:0 10px 30px rgba(0,0,0,.45);width:max-content;max-width:92vw;box-sizing:border-box;text-align:center;'
      /* a status line only: never swallow a tap meant for the Add to Cart button under it */
      + 'pointer-events:none;}';
    (document.head || document.documentElement).appendChild(st);
  }

  function toast(msg) {
    try {
      var old = document.getElementById('va-szk-toast'); if (old) old.remove();
      var t = document.createElement('div');
      t.id = 'va-szk-toast'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite');
      t.textContent = msg;
      document.body.appendChild(t);
      setTimeout(function () { try { t.remove(); } catch (e) {} }, 5200);
    } catch (e) {}
  }

  function close(wrap) {
    open = false;
    document.removeEventListener('keydown', onKey, true);
    try { wrap.remove(); } catch (e) {}
    try { if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true }); } catch (e) {}
  }
  var onKey = function () {};

  /* both label shapes drawn at the same px-per-mm, so the size difference is visible */
  function shape(wmm, hmm, name) {
    return '<span class="szk-stage" aria-hidden="true"><span class="szk-lab" style="width:' + Math.round(wmm * 1.6)
      + 'px;height:' + Math.round(hmm * 1.6) + 'px">' + name + '</span></span>';
  }

  /* opts: { match, switchLabel?, onSwitch?, switchHref?, onKeep?, onDismiss? }
     exactly one of onSwitch / switchHref is used for the primary action */
  function prompt(opts) {
    if (open) return;
    opts = opts || {};
    css();
    open = true;
    lastFocus = document.activeElement;
    var wrap = document.createElement('div');
    wrap.id = 'va-szk';
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.setAttribute('aria-labelledby', 'va-szk-h');
    wrap.setAttribute('aria-describedby', 'va-szk-p');
    var primary = opts.switchHref
      ? '<a class="szk-btn szk-go" href="' + String(opts.switchHref).replace(/&/g, '&amp;').replace(/"/g, '&quot;') + '"'
        + (opts.newTab ? ' target="_blank" rel="noopener"' : '') + '>'
        + (opts.switchLabel || 'Make it on 10 mL labels') + '</a>'
      : '<button type="button" class="szk-go">' + (opts.switchLabel || 'Switch to 10 mL labels') + '</button>';
    wrap.innerHTML =
      '<div class="szk-card" tabindex="-1">'
      + '<h3 id="va-szk-h">Is this for a 10 mL vial?</h3>'
      + '<p id="va-szk-p">Your label says <b>&ldquo;' + (opts.match || '10 mL') + '&rdquo;</b>, but you picked the '
      + '<b>3 mL label size</b>. That size is for 2&ndash;5 mL vials &mdash; typing 10 mL only changes the text, not the label size.'
      + (opts.note ? ' ' + opts.note : '') + '</p>'
      + '<div class="szk-sz"><div class="on">' + shape(45, 19, '3 mL') + '<b>3 mL label</b>45 &times; 19 mm &middot; 2&ndash;5 mL vials &middot; <i>selected</i></div>'
      + '<div>' + shape(63.5, 25.4, '10 mL') + '<b>10 mL label</b>63.5 &times; 25.4 mm &middot; 10 mL vials</div></div>'
      + '<div class="szk-acts">' + primary
      + '<button type="button" class="szk-keep">Keep 3 mL labels</button></div>'
      + '</div>';
    document.body.appendChild(wrap);

    var go = wrap.querySelector('.szk-go'), keep = wrap.querySelector('.szk-keep');
    /* the 2nd click of a double-click / double-tap on Add to Cart lands on this
       overlay: ignore clicks in the first 400 ms so it can't dismiss or answer
       the question before it has been read */
    var openedAt = Date.now();
    function early(e) {
      if (Date.now() - openedAt >= 400) return false;
      try { e.preventDefault(); e.stopPropagation(); } catch (x) {}
      return true;
    }
    if (go && opts.onSwitch) {
      go.addEventListener('click', function (e) {
        if (early(e)) return;
        close(wrap);
        try { opts.onSwitch(); } catch (x) {}
      });
    } else if (go && opts.switchHref) {
      /* same tab: the page navigates away. New tab: close once the link has fired. */
      go.addEventListener('click', function (e) {
        if (early(e)) return;
        open = false;
        if (opts.newTab) setTimeout(function () { close(wrap); }, 0);
      });
    }
    keep.addEventListener('click', function (e) {
      if (early(e)) return;
      if (opts.match && opts.sig) ack(opts.sig);
      close(wrap);
      try { if (opts.onKeep) opts.onKeep(); } catch (x) {}
    });
    /* backdrop / Esc = close without choosing: nothing happens, nothing is added */
    wrap.addEventListener('click', function (e) {
      if (e.target !== wrap || early(e)) return;
      close(wrap); try { if (opts.onDismiss) opts.onDismiss(); } catch (x) {}
    });
    onKey = function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault(); close(wrap); try { if (opts.onDismiss) opts.onDismiss(); } catch (x) {}
      } else if (e.key === 'Tab') {
        var f = [go, keep].filter(Boolean);
        var i = f.indexOf(document.activeElement);
        e.preventDefault();
        f[(i + (e.shiftKey ? f.length - 1 : 1)) % f.length].focus();
      }
    };
    document.addEventListener('keydown', onKey, true);
    /* opened by Add to Cart: focus the answer. Opened on its own while the
       customer may still be typing (opts.passive): focus the card itself, so a
       stray Enter/Space can't press Switch for them */
    try {
      if (opts.passive) wrap.querySelector('.szk-card').focus({ preventScroll: true });
      else (go || keep).focus({ preventScroll: true });
    } catch (e) {}
  }

  function val(id) { var e = document.getElementById(id); return e ? String(e.value || '') : ''; }
  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* is the customer in the middle of typing somewhere? (any text-entry control) */
  function typing(a) {
    a = a || document.activeElement;
    if (!a || a === document.body) return false;
    if (a.isContentEditable) return true;
    var t = String(a.tagName || '').toUpperCase();
    if (t === 'TEXTAREA') return true;
    if (t !== 'INPUT') return false;
    var ty = String(a.type || 'text').toLowerCase();
    return ['button', 'checkbox', 'radio', 'range', 'submit', 'reset', 'file', 'image', 'color'].indexOf(ty) < 0;
  }

  window.vaSizeCheck = { detect: detect, sigOf: sigOf, prompt: prompt, acked: acked, ack: ack, toast: toast, typing: typing, busy: function () { return open; } };

  /* Build a classic-builder link that carries what was typed over. The classic
     builder prefills from ?name/&dose/&lot (read from window.__vaQ0, which the
     layout freezes before it scrubs those params out of the address bar). */
  function tenUrl(name, dose, lot) {
    var q = [];
    if (name) q.push('name=' + encodeURIComponent(name));
    if (dose) q.push('dose=' + encodeURIComponent(dose));
    if (lot) q.push('lot=' + encodeURIComponent(lot));
    return TEN_URL + (q.length ? '&' + q.join('&') : '');
  }

  /* ================================================== classic builder */
  function wireClassic() {
    if (typeof window.vaSetDie !== 'function' || !document.getElementById('va-buy')) return false;

    function texts() {
      var t = [];
      try {
        if (typeof window.fields === 'function') {
          var f = window.fields();
          t.push(f.name, f.dose, f.lot, f.exp);
        }
      } catch (e) {}
      ['va-pep-other', 'va-name', 'va-dose', 'va-doseuc', 'va-dose-custom', 'va-lot',
       'va-brand', 'va-product', 'va-cstrength', 'va-csize', 'va-batch', 'va-cdir'].forEach(function (id) { t.push(val(id)); });
      /* dose number + unit as the label prints it: "10" + "mL" */
      var d = val('va-dose'), u = val('va-doseu');
      if (d && u && u !== '__c') t.push(d + ' ' + u);
      if (d && u === '__c') t.push(d + ' ' + val('va-doseuc'));
      return t;
    }
    function sig() { return sigOf(texts()); }
    function mismatch() {
      if ((window.VA_DIE || '3ml') !== '3ml') return null;
      return detect(texts());
    }
    function doSwitch(then) {
      var ok = false;
      try { ok = window.vaSetDie('10ml') !== false; } catch (e) { ok = false; }
      if (ok && window.VA_DIE === '10ml') {
        toast('Switched to 10 mL labels — check your preview and price, then add to cart.');
        try { if (typeof window.renderAll === 'function') window.renderAll(); } catch (e) {}
        try { if (typeof window.updateSummary === 'function') window.updateSummary(); } catch (e) {}
      } else {
        toast('10 mL labels aren’t available for this option right now — your 3 mL labels are unchanged.');
      }
      if (then) then(ok);
    }

    /* The order summary's "Label Size" row and the design step's subtitle are
       hardcoded to the 3 mL size in sections/vialart.liquid, so after any die
       change (a chip tap or this popup's Switch) they still said 1.75" x 0.75".
       Keep both in step with window.VA_DIE so a switch visibly lands. */
    var SIZE_TXT = { '3ml': '1.75″ × 0.75″', '10ml': '2.5″ × 1″' };
    var SIZE_RX = /(3|10) mL labels [0-9.]+″ × [0-9.]+″/;
    function syncSizeText() {
      var die = window.VA_DIE === '10ml' ? '10ml' : '3ml';
      try {
        document.querySelectorAll('.os-meta > div').forEach(function (row) {
          var k = row.querySelector('span'), v = row.querySelector('b');
          if (k && v && /^\s*Label Size\s*$/i.test(k.textContent) && v.textContent !== SIZE_TXT[die]) v.textContent = SIZE_TXT[die];
        });
        document.querySelectorAll('.va-sec-title p').forEach(function (p) {
          for (var n = p.firstChild; n; n = n.nextSibling) {
            if (n.nodeType === 3 && SIZE_RX.test(n.nodeValue)) {
              n.nodeValue = n.nodeValue.replace(SIZE_RX, (die === '10ml' ? '10' : '3') + ' mL labels ' + SIZE_TXT[die]);
            }
          }
        });
      } catch (e) {}
    }
    if (!window.vaSetDie.__vaSzk) {
      var origSet = window.vaSetDie;
      var setW = function () { var r = origSet.apply(this, arguments); syncSizeText(); return r; };
      setW.__vaSzk = 1;
      window.vaSetDie = setW;
    }
    syncSizeText();

    /* (a) Add to Cart / review entry points - capture phase, before the
       builder's own listeners (and the mobile wizard's) see the click */
    var BYPASS = false;
    var ENTRY = '#va-buy,#va-mbar-btn,.va-buy2';
    document.addEventListener('click', function (e) {
      if (BYPASS) return;
      var trig = e.target && e.target.closest ? e.target.closest(ENTRY) : null;
      if (!trig || trig.disabled) return;
      var m = mismatch();
      if (!m || acked(sig())) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      prompt({
        match: m, sig: sig(),
        onSwitch: function () { doSwitch(); },
        onKeep: function () {
          /* continue exactly where they were: replay the same click */
          BYPASS = true;
          try { trig.click(); } catch (x) {}
          BYPASS = false;
        }
      });
    }, true);

    /* programmatic review opens (the mobile wizard calls window.openReview) */
    if (typeof window.openReview === 'function' && !window.openReview.__vaSzk) {
      var orig = window.openReview;
      var wrapped = function () {
        var self = this, args = arguments;
        var m = BYPASS ? null : mismatch();
        if (!m || acked(sig())) return orig.apply(self, args);
        prompt({
          match: m, sig: sig(),
          onSwitch: function () { doSwitch(); },
          onKeep: function () { orig.apply(self, args); }
        });
      };
      wrapped.__vaSzk = 1;
      window.openReview = wrapped;
    }

    /* (b) one gentle nudge when a field is committed with "10 mL" */
    var FIELDS = '#va-name,#va-pep-other,#va-dose,#va-doseu,#va-doseuc,#va-dose-custom,#va-lot,#va-exp,#va-csize,'
      + '#va-cstrength,#va-product,#va-brand,#va-batch,#va-cdir';
    var tmr = null;
    function later() {
      clearTimeout(tmr);
      tmr = setTimeout(function () {
        var m = mismatch(), s = sig();
        if (!m || acked(s) || nudged[key(s)] || open) return;
        /* never interrupt someone mid-word, in ANY text box on the page */
        if (typing()) { later(); return; }
        nudged[key(s)] = 1;
        prompt({ match: m, sig: s, passive: true, onSwitch: function () { doSwitch(); } });
      }, 900);
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches(FIELDS)) later();
    }, true);
    document.addEventListener('focusout', function (e) {
      if (e.target && e.target.matches && e.target.matches(FIELDS)) later();
    }, true);
    /* strength / unit bubbles set values without a change event */
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.va-bub,.va-unit,.va-doseu-chip,#va-dosepick')) later();
    }, true);
    return true;
  }

  /* ============================== beta builder (/pages/build-beta): 3 mL only */
  function wireBeta() {
    var rev = document.getElementById('vbf-review');
    if (!rev) return false;
    function f() { try { return typeof window.fields === 'function' ? window.fields() : {}; } catch (e) { return {}; } }
    function texts() { var x = f(); return [x.name, x.name2, x.dose, x.lot, x.exp]; }
    function sig() { return sigOf(texts()); }
    function offer(then, passive) {
      var x = f(), m = detect(texts());
      if (!m || acked(sig())) return false;
      prompt({
        match: m, sig: sig(), passive: !!passive,
        note: 'This builder makes 3 mL labels only.',
        switchLabel: 'Make it on 10 mL labels',
        switchHref: tenUrl(x.name, x.dose, x.lot),
        onKeep: then
      });
      return true;
    }
    var BYPASS = false;
    document.addEventListener('click', function (e) {
      if (BYPASS) return;
      var trig = e.target && e.target.closest ? e.target.closest('#vbf-review') : null;
      if (!trig) return;
      if (offer(function () { BYPASS = true; try { trig.click(); } catch (x) {} BYPASS = false; })) {
        e.preventDefault(); e.stopImmediatePropagation();
      }
    }, true);
    var tmr = null;
    document.addEventListener('change', function (e) {
      if (!(e.target && e.target.matches && e.target.matches('#vbf-name,#vbf-name2,#vbf-dose,#vbf-doseu,#vbf-doseuc,#vbf-lot'))) return;
      clearTimeout(tmr);
      tmr = setTimeout(function () {
        var s = sig();
        if (open || nudged[key(s)] || !detect(texts()) || acked(s)) return;
        if (typing()) return;
        nudged[key(s)] = 1; offer(null, true);
      }, 900);
    }, true);
    return true;
  }

  /* ========================================== Bulk Mix & Match: 3 mL only */
  function wireBulk() {
    var atc = document.getElementById('vamx-atc');
    if (!atc) return false;
    /* one row as the label prints it: the strength is number + unit side by side
       (the unit <select> reads "__c" when the customer typed their own unit) */
    function rowData(r) {
      function v(sel) { var e = r.querySelector(sel); return e ? String(e.value || '').trim() : ''; }
      var unit = v('select.vamx-dunit');
      if (unit === '__c') unit = v('.vamx-dcust');
      var n = v('[data-k="doseNum"]');
      var d = { name: v('[data-k="compound"]'), dose: n ? (n + ' ' + unit).trim() : '', lot: v('[data-k="lot"]'), texts: [] };
      r.querySelectorAll('input,select').forEach(function (el) {
        if (el.type === 'file' || el.type === 'checkbox' || el.type === 'radio') return;
        var k = el.getAttribute('data-k') || '';
        /* qty is a count and the QR link is encoded, not printed: neither is label text */
        if (k === 'qty' || k === 'qr' || k === 'doseNum' || (el.matches && el.matches('.vamx-dunit,.vamx-dcust'))) return;
        d.texts.push(String(el.value || ''));
      });
      d.texts.push(d.dose);
      return d;
    }
    function rows() {
      var out = [];
      document.querySelectorAll('#vamx-rows .vamx-r').forEach(function (r) { out.push(rowData(r)); });
      return out;
    }
    function allTexts(rs) { var t = []; rs.forEach(function (d) { t = t.concat(d.texts); }); return t; }
    var BYPASS = false;
    document.addEventListener('click', function (e) {
      if (BYPASS) return;
      var trig = e.target && e.target.closest ? e.target.closest('#vamx-atc') : null;
      if (!trig || trig.disabled) return;
      var rs = rows(), t = allTexts(rs), m = detect(t), s = sigOf(t);
      if (!m || acked(s)) return;
      e.preventDefault(); e.stopImmediatePropagation();
      /* carry the flagged row over exactly as typed: its name, strength and lot */
      var row = null, idx = -1, els = document.querySelectorAll('#vamx-rows .vamx-r');
      for (var i = 0; i < rs.length; i++) { if (detect(rs[i].texts)) { row = rs[i]; idx = i; break; } }
      row = row || { name: '', dose: '', lot: '' };
      /* say WHICH row, and mark it, so the customer can find and remove it after
         making it on 10 mL labels (else they come back, hit this again, press Keep
         and get it twice, once at the wrong size) */
      var which = idx >= 0 ? 'Row ' + (idx + 1) + (row.name ? ' (&ldquo;' + esc(row.name.slice(0, 40)) + '&rdquo;)' : '') : 'One row';
      var el = idx >= 0 ? els[idx] : null;
      if (el) {
        try {
          el.style.outline = '2px solid #ffb74d'; el.style.outlineOffset = '3px';
          el.scrollIntoView({ block: 'center', behavior: 'smooth' });
          var clear = function () { el.style.outline = ''; el.style.outlineOffset = ''; el.removeEventListener('input', clear, true); };
          el.addEventListener('input', clear, true);
        } catch (x) {}
      }
      prompt({
        match: m, sig: s,
        note: which + ' needs a 10 mL label. Bulk Mix makes 3 mL labels only, so make it in the label builder '
          + '(it opens in a new tab), then remove that row here.',
        switchLabel: 'Make a 10 mL label',
        switchHref: tenUrl(row.name.slice(0, 60), row.dose, row.lot),
        newTab: true,
        onKeep: function () { BYPASS = true; try { trig.click(); } catch (x) {} BYPASS = false; }
      });
    }, true);
    return true;
  }

  function boot() {
    try { wireClassic(); } catch (e) {}
    try { wireBeta(); } catch (e) {}
    try { wireBulk(); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
